import React from 'react'
import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import AndroidHandler from 'utils/androidHandler'

const PageHeader = () => {
  const router = useRouter()
  const androidHandler = AndroidHandler()

  return (
    <HeaderBar borderless fixed className="z-10">
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            arrow_back
          </Icon>
        }
        onClick={async () => {
          if (androidHandler.enabled) {
            androidHandler.backToApp()
          } else {
            await router.back()
          }
        }}
      />
      <HeaderBarTitle>Pelatihan Mandiri</HeaderBarTitle>
    </HeaderBar>
  )
}

export default PageHeader
